import { CSSProperties, useCallback, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  link: string;
  size?: number;
}

const QRCode = ({ className, link, size = 148 }: Props) => {
  const [qrCode, setQrCode] = useState<any | null>(null);
  useEffect(() => {
    const qrCodeStyling = require('qr-code-styling');
    setQrCode(
      new qrCodeStyling({
        margin: 0,
        data: link,
        width: size,
        height: size,
      }),
    );
  }, [link, size]);

  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      if (node !== null) {
        // Clear any existing QR code before appending the new one
        while (node.firstChild) {
          node.removeChild(node.firstChild);
        }
        qrCode?.append(node);
      }
    },
    [qrCode],
  );

  return (
    <div
      style={{ '--qr-size': size } as CSSProperties}
      className={twMerge(
        'mx-auto h-[var(--qr-size)] w-[var(--qr-size)] [&>canvas]:h-[var(--qr-size)] [&>canvas]:w-[var(--qr-size)]',
        className,
      )}
      ref={ref}
    />
  );
};

export default QRCode;
